import React, { Component } from 'react';
import classNames from 'classnames';

import Asset from '../../global/Asset';
import withModifierDetails from './WithModifierDetails';
import { getActiveModifierOption } from '../../global/ProductHelpers';

export class Icons extends Component {
  static splitIconsIntoRows(icons) {
    const rowLength = Math.ceil(icons.length / 2);
    const firstRow = icons.slice(0, rowLength);
    const secondRow = icons.slice(rowLength);

    return [firstRow, secondRow];
  }

  render(activeOption) {
    const {
      modifier: {
        className,
        options = [],
      },
    } = this.props;

    const wrapIcons = className?.includes('wrap');

    let iconRows = [options];
    if (wrapIcons) {
      iconRows = Icons.splitIconsIntoRows(options);
    }

    return iconRows.map((icons, row) => (
      <div className={classNames('pdp-options-ul')} key={row}>
        {icons.map((option) => {
          const {
            value,
            description,
            asset,
          } = option;

          const active = getActiveModifierOption(activeOption, value);

          return (
            <div
              role="button"
              key={option.value}
              aria-label={description}
              onClick={() => this.selectModifierOption(option)}
              className={classNames(value, 'pdp-options-icon', {
                active,
              })}
            >
              <Asset asset={asset} />
            </div>
          );
        })}
      </div>
    ));
  }
}

const IconsModifier = withModifierDetails(Icons);

export default IconsModifier;
